// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5ea17ecb","703":"dbbf10f8"}[chunkId] + ".chunk.js";
};